import React from 'react';
import { useHeaderData } from '../hooks/use-header-data';
import { MiroLogo } from '@miro-site/ui-design-system';
import { jsx as _jsx } from "react/jsx-runtime";
export var HeaderLogo = function HeaderLogo() {
  var headerData = useHeaderData();
  return /*#__PURE__*/_jsx("div", {
    className: "align-self-center me-300",
    children: /*#__PURE__*/_jsx("a", {
      "aria-label": "Go to the main page",
      href: headerData !== null && headerData !== void 0 && headerData.isLoggedIn ? '/index' : '/',
      tabIndex: -1,
      children: /*#__PURE__*/_jsx(MiroLogo, {})
    })
  });
};